module.exports = __webpack_public_path__ + "Flama-Bold.ttf?cf7906adbdd39f4446d204693286630a";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Bold.ttf
// module id = 907
// module chunks = 0